export class EdpSelectList {
    public value: string;
    public text: string;
    public description?: string;
    public selected?: boolean;
    public data?: any;
    public index?: number;
    public type?: string;
    constructor(
         value: string ,
         text: string,
         selected: boolean = false,
         description?: string,
         data?: any,
         index?: number,
         type?: string
    ) {
        this.value =  value;
        this.text = text;
        this.selected = selected;
        this.description = description;
        this.data = data;
        this.index = index;
        this.type = type;
    }
}
